import { DateRange } from './date-range';
import { IndustryCategory } from './industry-category';
import { MinMaxRange } from './min-max-range';

export class SkuRequestFilter {
    constructor(
        public attributeIds: Array<number> = [],
        public brandIds: Array<number> = [],
        public categoryIds: Array<number> = [],
        public countryIds: Array<number> = [],
        public retailerIds: Array<number> = [],
        public supplierIds: Array<number> = [],
        public subBrandIds: Array<number> = [],
        public retailerTypeIds: Array<number> = [],
        public attributeGroupIds: Array<number> = [],
        public promotionTypeIds: Array<number> = [],
        public categories: Array<IndustryCategory> = [],
        public firstSeenPriceRange: MinMaxRange | null = null,
        public lastSeenPriceRange: MinMaxRange | null = null,
        public volumeRange: MinMaxRange | null = null,
        public weightRange: MinMaxRange | null = null,
        public countRange: MinMaxRange | null = null,
        public dateRange: DateRange | null = null,
    ) {}
}
